export type LeadSubmitPayload = {
  formId: string
  source?: string
  page?: string
  emailDomain?: string
  hasPhone?: boolean
}

export type AskAiPayload = {
  page?: string
  questionLength: number
}

export type AtlasPageViewPayload = {
  page?: string
}

export type AtlasDemoStartPayload = {
  page?: string
  demoId: string
}

export type AtlasUseCaseSwitchPayload = {
  page?: string
  useCase: string
  label: string
}

export type CtaPlacement = "hero" | "middle" | "final"

export type AtlasCtaPlacement = CtaPlacement

/** Открытие формы раннего доступа — единственного CTA сайта. */
export type EarlyAccessOpenPayload = {
  page?: string
  source: string
  placement: CtaPlacement
}

export type AtlasCtaClickPayload = {
  page?: string
  placement: AtlasCtaPlacement
  label: string
  href: string
}

export type AtlasRegistrationFlowStartPayload = {
  page?: string
  placement: AtlasCtaPlacement
  href: string
}

type GtmEventMap = {
  lead_submit: LeadSubmitPayload
  ask_ai_submit: AskAiPayload
  atlas_page_view: AtlasPageViewPayload
  atlas_demo_start: AtlasDemoStartPayload
  atlas_use_case_switch: AtlasUseCaseSwitchPayload
  atlas_cta_click: AtlasCtaClickPayload
  atlas_registration_flow_start: AtlasRegistrationFlowStartPayload
  early_access_open: EarlyAccessOpenPayload
}

type GtmEventName = keyof GtmEventMap

type DataLayerEvent<Name extends GtmEventName> = {
  event: Name
  event_time: string
} & GtmEventMap[Name]

declare global {
  interface Window {
    dataLayer: Array<Record<string, unknown>>
  }
}

const isBrowser = () => typeof window !== "undefined"

export const extractEmailDomain = (email?: string | null) => {
  if (!email) return undefined
  const domain = email.split("@")[1] as string | undefined
  const normalized = domain?.trim().toLowerCase()
  return normalized || undefined
}

export const pushGtmEvent = <Name extends GtmEventName>(
  name: Name,
  payload: GtmEventMap[Name],
) => {
  if (!isBrowser()) return

  const globalWindow = window as unknown as {
    dataLayer?: Array<Record<string, unknown>>
  }
  const dataLayer = globalWindow.dataLayer ?? []
  window.dataLayer = dataLayer

  const eventPayload: DataLayerEvent<Name> = {
    event: name,
    event_time: new Date().toISOString(),
    ...payload,
  }

  dataLayer.push(eventPayload)

  if (process.env.NODE_ENV !== "production") {
    console.info("[GTM] event pushed", eventPayload)
  }
}
